<template>
  <b-form-group
    label="Güncelleme Notu"
    label-for="update_notes"
  >
    <validation-provider
      #default="{ errors }"
      name="Güncelleme Notu"
      rules="required"
    >
      <b-form-textarea
        id="update_notes"
        v-model="dataItem.update_notes"
        placeholder="Güncelleme Notu"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'UpdateNotes',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
